import { type PropsWithChildren } from 'react';

import { useFormatter } from '../../context/FormatterContext.js';

export interface MeterBarChartFormattedValueProps {
  value: number;
  total?: number;
  auto?: boolean;
}

/**
 * Component responsible to render a formatted value.
 * When auto=true the component will generate the default label(e.g. value/total).
 * @param value -
 * @param total -
 * @param auto -
 * @param children -
 */
export const MeterBarChartFormattedValue = ({
  value,
  total,
  auto,
  children,
}: PropsWithChildren<MeterBarChartFormattedValueProps>) => {
  const { formatter, unit } = useFormatter();

  if (auto) {
    if (total !== undefined) {
      return `${formatter(value, unit)}/${formatter(total, unit)}`;
    }

    return formatter(value, unit);
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

MeterBarChartFormattedValue['displayName'] = 'MeterBarChartFormattedValue';
